import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_FULFILLMENT_SETTINGS = `${URL_RETAILER_SCOPED}/fulfillment-settings`
const URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES = `${URL_FULFILLMENT_SETTINGS}/order-orchestration`
const URL_FULFILLMENT_SETTINGS_CREATE_FULFILLMENT_RULE = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/create`
const URL_FULFILLMENT_SETTINGS_BANNER_RULE_MANAGEMENT = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/banner/:bannerId`
const URL_FULFILLMENT_SETTINGS_STORE_RULE_MANAGEMENT = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/store/:bannerId/:storeId`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'fulfillment-settings'>
  | DashRouteType<'fulfillment-settings-list-fulfillment-rules'>
  | DashRouteType<'fulfillment-settings-create-fulfillment-rule'>
  | DashRouteType<'fulfillment-settings-banner-rule-management'>
  | DashRouteType<'fulfillment-settings-store-rule-management'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'fulfillment-settings': URL_FULFILLMENT_SETTINGS,
  'fulfillment-settings-list-fulfillment-rules': URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES,
  'fulfillment-settings-create-fulfillment-rule': URL_FULFILLMENT_SETTINGS_CREATE_FULFILLMENT_RULE,
  'fulfillment-settings-banner-rule-management': URL_FULFILLMENT_SETTINGS_BANNER_RULE_MANAGEMENT,
  'fulfillment-settings-store-rule-management': URL_FULFILLMENT_SETTINGS_STORE_RULE_MANAGEMENT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
